import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import { ExternalIdPLogin, ExternalIdPLoginProps } from './ExternalIdPLogin';
import { UsernameAndPasswordLogin, UsernameAndPasswordLoginProps } from './UsernameAndPasswordLogin';
import React = require('react');

export function SamlLogin(props: UsernameAndPasswordLoginProps | ExternalIdPLoginProps) {

  const isSamlDisabledForThisClient = props.signinQueryParams.client_type === 'desktop' &&
    ServerSettingsUnauthenticated.isDesktopSamlDisabled();

  if (isSamlDisabledForThisClient) {
    return <UsernameAndPasswordLogin {...props} />;
  } else {
    return <ExternalIdPLogin {...props} />;
  }
}
